import {
    BACK_TO_TOPICS,
    COUNSELLING_DO_SOMETHING_ABOUT_IT,
    FORUM_TOPIC_IS_PRIVATE_ANCMT_DETAIL,
    FORUM_TOPIC_IS_PRIVATE_ANCMT_MESSAGE,
    NO_QUESTIONS_FOR_THIS_COUNSELLING_action_btn,
    THERES_NO_POSTS_IN_TOPIC_DO_SOMETHING_WITH_IT,
    TOPIC_CONTESTS_ENDED_TITLE,
    TOPIC_CONTESTS_NO_RUNNING,
    TOPIC_CONTESTS_RUNNING_TITLE,
    TOPIC_DELETED_BECAUSE_reason,
    TOPIC_HAS_BEEN_DELETED,
} from 'mk/autogenerated/translations/Topic.fca030b357beacdfd70f03d15fcfcae8'
import { isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { counsellingsNewUrl } from 'mk2/apps/counsellings/urls';
import { BrandDaysCampaignBanner } from 'mk2/apps/forum/components/BrandDaysCampaignBanner';
import Feed from 'mk2/apps/forum/components/Feed';
import FeedPost from 'mk2/apps/forum/components/FeedPost';
import TopicHeader, { TopicHeaderPlaceholder } from 'mk2/apps/forum/components/TopicHeader';
import {
    CONTESTS_TOPIC_ID,
    DAYS_WITH_CATEGORY_ID,
    READ_FEED_TIMEOUT,
    TESTINGS_TOPIC_ID,
    TOPIC_VISIBILITY_PRIVATE,
} from 'mk2/apps/forum/constants';
import { Props } from 'mk2/apps/forum/containers/Topic/TopicPage';
import { forumTopicsUrl } from 'mk2/apps/forum/urls';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import Btn, { BtnType } from 'mk2/components/Btn';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { FormPageType } from 'mk2/constants';
import { url } from 'mk2/helpers/urls';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { trackReach, TrackReachProduct } from 'mk2/trackReach';
import React from 'react';
import styles from './Topic.mscss';

interface State {
    alreadyRead: boolean;
}

class Topic extends React.Component<Props, State> {
    public state: State = {
        alreadyRead: false,
    };

    private readTimer: number;

    public componentDidMount() {
        const { topic, brandDaysCampaign, location, counselling, onStoreEvent, onRead } = this.props;
        if (topic && brandDaysCampaign) {
            if (topic.category.id === DAYS_WITH_CATEGORY_ID) {
                trackReach(location, TrackReachProduct.DAYS_WITH, brandDaysCampaign.name, 'forum');
            }
        }
        if (topic && counselling) {
            onStoreEvent('counselling_visit', {
                counselling_name: topic.slug,
            });
        }

        if (topic) {
            this.readTimer = window.setTimeout(this.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { topic, brandDaysCampaign, location, counselling, onStoreEvent, onRead } = this.props;

        if (topic && brandDaysCampaign && (location !== prevProps.location || !prevProps.brandDaysCampaign)) {
            if (topic.category.id === DAYS_WITH_CATEGORY_ID) {
                trackReach(location, TrackReachProduct.DAYS_WITH, brandDaysCampaign.name, 'forum');
            }
        }

        if (
            topic && (
                counselling && prevProps.counselling && counselling.id !== prevProps.counselling.id ||
                counselling && !prevProps.counselling
            )
        ) {
            onStoreEvent('counselling_visit', {
                counselling_name: topic.slug,
            });
        }

        if (topic && !this.state.alreadyRead) {
            window.clearTimeout(this.readTimer);
            this.readTimer = window.setTimeout(this.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentWillUnmount() {
        window.clearTimeout(this.readTimer);
    }

    public shouldComponentUpdate(n: Props) {
        const p = this.props;

        return p.posts !== n.posts
            || p.after !== n.after
            || p.hashtags.join(',') !== n.hashtags.join(',')
            || p.isSubscribed !== n.isSubscribed
            || p.complaintsStatistics !== n.complaintsStatistics;
    }

    public render() {
        const {
            topic,
            loadingState,
            isSubscribed,
            isFavorite,
            brandDaysCampaign,
            brandDaysCampaignGreetingText,
            counselling,
            counsellingPostsCount,
            requestUser,
            onSubscribe,
            onUnsubscribe,
            onAddToFavorites,
            onRemoveFromFavorites,
            onUploadFiles,
            permissions,
            staticContext,
            subscribers,
            mobile,
            onTopicCoverToggleMenuMore,
            onTopicCoverSave,
            onTopicCoverRemove,
            currentFormPage,
            viewType,
        } = this.props;

        const isModerator = topic && isAuthenticatedAs(requestUser, topic.moderators);
        const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;
        const isDeleted = topic && !!topic.deletedAt;
        const isPrivate = topic && topic.visibility === TOPIC_VISIBILITY_PRIVATE;

        if (isDeleted && staticContext) {
            staticContext.statusCode = 410;
        }

        return (
            <div>
                {(loadingState === null || loadingState === LoadingState.INIT || (loadingState === LoadingState.LOADING && !topic)) && (
                    <TopicHeaderPlaceholder />
                )}
                {(isSuccess(loadingState) || topic) && (
                    <div>
                        <TopicHeader
                            topic={topic}
                            counselling={counselling}
                            counsellingPostsCount={counsellingPostsCount}
                            topicLoadingState={loadingState}
                            isSubscribed={isSubscribed}
                            isFavorite={isFavorite}
                            requestUser={requestUser}
                            permissions={permissions}
                            currentFormPage={currentFormPage}
                            onSubscribe={onSubscribe}
                            onUnsubscribe={onUnsubscribe}
                            onAddToFavorites={onAddToFavorites}
                            onRemoveFromFavorites={onRemoveFromFavorites}
                            onUploadFiles={onUploadFiles}
                            onTopicCoverToggleMenuMore={onTopicCoverToggleMenuMore}
                            onTopicCoverSave={onTopicCoverSave}
                            onTopicCoverRemove={onTopicCoverRemove}
                            isModerator={isModerator}
                            subscribers={subscribers}
                            mobile={mobile}
                            viewType={viewType}
                        />
                        {brandDaysCampaign && (currentFormPage !== FormPageType.ChangeTopicCover) && (
                             <BrandDaysCampaignBanner
                                 brandDaysCampaign={brandDaysCampaign}
                                 brandDaysCampaignGreetingText={brandDaysCampaignGreetingText}
                             />
                        )}
                    </div>
                )}
                {currentFormPage !== FormPageType.ChangeTopicCover && (
                    <>
                        {isPrivate && (
                            <AnnouncementBox
                                type={BoxType.Yellow}
                                hasDetailMessage
                                message={FORUM_TOPIC_IS_PRIVATE_ANCMT_MESSAGE}
                                detailMessage={FORUM_TOPIC_IS_PRIVATE_ANCMT_DETAIL}
                            />
                        )}
                        {isDeleted && (
                            <AnnouncementBox
                                message={TOPIC_HAS_BEEN_DELETED}
                                hasDetailMessage={isAdmin || isModerator}
                                detailMessage={topic.deletedReason}
                                deletedAt={topic.deletedAt}
                                deletedBy={isAdmin && topic.deletedBy ? topic.deletedBy.username : null}
                                icon={'fa fa-trash'}
                                type={BoxType.Deleted}
                                reasonValue={TOPIC_DELETED_BECAUSE_reason}
                            />
                        )}
                        {(!isDeleted || (isDeleted && isAdmin)) &&
                            (topic && topic.id === CONTESTS_TOPIC_ID
                                ? this.renderContestFeed()
                                : this.renderNormalFeed())}
                        {/* isAnonymous(requestUser) && topic && (forumTopicsWithNewsletterModal.indexOf(topic.slug) >= 0) && (
                            <NewsletterModal />
                        ) */}
                    </>
                )}
            </div>
        );
    }

    private renderNormalFeed() {
        const {
            topic,
            loadingState,
            counselling,
            mobile,
            posts,
            after,
            hasNext,
            hasPrevious,
            baseUrl,
            errorMessage,
            complaintsStatistics,
            location,
        } = this.props;

        const isDeleted = topic && !!topic.deletedAt;

        return (
            <Feed
                posts={posts}
                after={after}
                hasNext={hasNext}
                hasPrevious={hasPrevious}
                mobile={mobile}
                errorMessage={errorMessage}
                baseUrl={baseUrl}
                complaintsStatistics={complaintsStatistics}
                location={location}
                showCreated={!topic || topic.id !== TESTINGS_TOPIC_ID}
                showSticky
                noResults={
                    counselling ? (
                        <Interpolate
                            i18nKey={NO_QUESTIONS_FOR_THIS_COUNSELLING_action_btn}
                            action_btn={(
                                <Link to={url(counsellingsNewUrl, { topicSlug: topic.slug })}>
                                    {COUNSELLING_DO_SOMETHING_ABOUT_IT}
                                </Link>
                            )}
                        />
                    ) : (
                        THERES_NO_POSTS_IN_TOPIC_DO_SOMETHING_WITH_IT
                    )
                }
                loadingState={loadingState}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_TOPICS}
                        icon="fa-arrow-left"
                        link={forumTopicsUrl}
                    />
                }
                onLoad={this.onLoad}
                readonlyPosts={isDeleted}
            />
        );
    }

    private renderContestFeed() {
        const {
            topic,
            loadingState,
            counselling,
            mobile,
            posts,
            after,
            hasNext,
            hasPrevious,
            baseUrl,
            errorMessage,
            complaintsStatistics,
            location,
        } = this.props;

        const isDeleted = topic && !!topic.deletedAt;

        const runningPosts = posts.filter((p) => !p.contestEnded);
        const endedPosts = posts.filter((p) => p.contestEnded);

        return (
            <>
                <h4 className={styles.Topic__smallHeading}>{TOPIC_CONTESTS_RUNNING_TITLE}</h4>

                {runningPosts.length > 0 ? (
                    <div className={styles.Topic__runningContests}>
                        {runningPosts.map((post) => (
                            <FeedPost
                                key={post.id}
                                post={post}
                                mobile={mobile}
                                showTopic={false}
                                showSticky
                                showCreated={!topic || topic.id !== TESTINGS_TOPIC_ID}
                                complaintsCount={
                                    complaintsStatistics[post.id]
                                        ? complaintsStatistics[post.id].count
                                        : 0
                                }
                                readonlyPosts={isDeleted}
                                showAuthor
                                showCheckMark={false}
                            />
                        ))}
                    </div>
                ) : (
                    <div className={styles.Topic__noRunnigContest}>{TOPIC_CONTESTS_NO_RUNNING}</div>
                )}

                <h4 className={styles.Topic__smallHeading}>{TOPIC_CONTESTS_ENDED_TITLE}</h4>
                <Feed
                    posts={endedPosts}
                    after={after}
                    hasNext={hasNext}
                    hasPrevious={hasPrevious}
                    mobile={mobile}
                    errorMessage={errorMessage}
                    baseUrl={baseUrl}
                    complaintsStatistics={complaintsStatistics}
                    location={location}
                    showCreated={!topic || topic.id !== TESTINGS_TOPIC_ID}
                    showSticky
                    noResults={
                        counselling ? (
                            <Interpolate
                                i18nKey={NO_QUESTIONS_FOR_THIS_COUNSELLING_action_btn}
                                action_btn={
                                    <Link
                                        to={url(counsellingsNewUrl, {
                                            topicSlug: topic.slug,
                                        })}
                                    >
                                        {COUNSELLING_DO_SOMETHING_ABOUT_IT}
                                    </Link>
                                }
                            />
                        ) : (
                            THERES_NO_POSTS_IN_TOPIC_DO_SOMETHING_WITH_IT
                        )
                    }
                    loadingState={loadingState}
                    backButton={
                        <Btn
                            type={BtnType.Blue}
                            label={BACK_TO_TOPICS}
                            icon="fa-arrow-left"
                            link={forumTopicsUrl}
                        />
                    }
                    onLoad={this.onLoad}
                    readonlyPosts={isDeleted}
                />
            </>
        );
    }

    private onLoad = (after?: number) => {
        const {
            onLoad,
            hashtags,
            match: {
                params: { topicSlug },
            },
        } = this.props;
        onLoad(topicSlug, hashtags, after);
    };

    private onRead = () => {
        const { topic, onRead } = this.props;
        if (onRead) {
            // Read only once
            this.setState({ alreadyRead: true });
            onRead(topic.id);
        }
    };
}

export default Topic;
